/**
 * Fall backdrop: layered rolling autumn hills along the bottom, a flat sun in
 * the upper-right, and a few distant birds — behind content,
 * `pointer-events: none`. Scene colors come from theme vars (`--hill-1..4`,
 * `--sun`, `--bird`) so it adapts light (day) / dark (dusk → pale moon). The sky
 * gradient itself is on the theme `body` (CSS).
 */
import React from 'react';

import { Z } from '@shared/constants/zIndex';

/** Fixed rolling-hills + flat-sun backdrop. */
export const FallBackdrop: React.FC = () => (
  <div
    aria-hidden
    data-testid="fall-backdrop"
    className="pointer-events-none fixed inset-0"
    style={{ zIndex: Z.BACKDROP }}
  >
    {/* Flat sun (or moon, in dusk) — a solid disc, upper-right. */}
    <div
      className="absolute rounded-full"
      style={{ top: '11%', right: '9%', width: '7vw', height: '7vw', background: 'var(--sun)' }}
    />

    {/* Distant birds. */}
    <svg
      className="absolute"
      style={{ top: '20%', left: '14%', width: '26%', height: '10%' }}
      viewBox="0 0 120 30"
      preserveAspectRatio="xMidYMid meet"
    >
      <g stroke="var(--bird)" strokeWidth="1.6" fill="none" strokeLinecap="round">
        <path d="M6,12 Q11,7 16,12 Q21,7 26,12" />
        <path d="M44,20 Q48,16 52,20 Q56,16 60,20" />
        <path d="M82,9 Q86,5 90,9 Q94,5 98,9" />
      </g>
    </svg>

    {/* Layered rolling hills (back → front). */}
    <svg
      className="absolute bottom-0 left-0 w-full"
      style={{ height: '38vh', maxHeight: '24rem' }}
      viewBox="0 0 400 120"
      preserveAspectRatio="none"
    >
      <path d="M0,120 Q70,52 150,60 Q250,70 320,46 Q360,34 400,50 V120 Z" fill="var(--hill-1)" />
      <path d="M0,120 Q110,60 220,74 Q300,84 400,68 V120 Z" fill="var(--hill-2)" />
      <path d="M0,120 Q90,90 200,96 Q300,101 400,86 V120 Z" fill="var(--hill-3)" />
      <path d="M0,120 Q140,108 280,112 Q340,114 400,106 V120 Z" fill="var(--hill-4)" />
    </svg>
  </div>
);
